import SectionHeading from "@/components/base/SectionHeading";

const steps = [
  {
    id: "01",
    title: "选定同一基准",
    text: "同一品类的测评尽量安排在同一时段、同一收货地址，减少天气与路况带来的干扰，让结果更可比。",
  },
  {
    id: "02",
    title: "记录客观数据",
    text: "下单时间、送达用时、净含量、实际分量、包装完整度都会逐一记录并拍照留档。",
  },
  {
    id: "03",
    title: "分维度打分",
    text: "由测评小组各自独立打分后再取平均，意见不一致的部分会写在测评正文里，不做统一口径。",
  },
  {
    id: "04",
    title: "给出明确结论",
    text: "最终必须落到一句话结论：值得复购、可以尝鲜，还是建议谨慎选择，并说明理由。",
  },
];

const dimensions = [
  { label: "口味还原度", weight: 40, tone: "bg-primary-500" },
  { label: "性价比", weight: 25, tone: "bg-accent-500" },
  { label: "出餐与配送体验", weight: 20, tone: "bg-secondary-500" },
  { label: "复购意愿", weight: 15, tone: "bg-foreground-600" },
];

export default function MethodSection() {
  return (
    <section id="method" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="测评方法"
          title="一次测评是怎么做出来的"
          description="为了让评分可对照、可复核，我们把流程固定成四步，并公开各维度的权重。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
          <ol className="flex flex-col gap-4 lg:col-span-3">
            {steps.map((step, index) => (
              <li
                key={step.id}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {step.id}
                </span>
                <div className="flex flex-col gap-1.5">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {index + 1}. {step.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{step.text}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="flex flex-col gap-4 lg:col-span-2">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">评分维度与权重</h3>
              <p className="mt-1.5 text-xs text-foreground-500">总分由以下四项加权得出，满分 5 分。</p>
              <ul className="mt-5 flex flex-col gap-4">
                {dimensions.map((dim) => (
                  <li key={dim.label} className="flex flex-col gap-2">
                    <div className="flex items-center justify-between text-xs font-medium text-foreground-700">
                      <span>{dim.label}</span>
                      <span>{dim.weight}%</span>
                    </div>
                    <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${dim.tone}`}
                        style={{ width: `${dim.weight}%` }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-accent-300 bg-accent-50 p-6">
              <div className="flex items-center gap-2 text-accent-800">
                <i className="ri-shield-check-line text-lg" aria-hidden="true" />
                <h3 className="font-heading text-base font-bold">独立与透明</h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-accent-900">
                商家提供的样品不影响评分标准；如存在合作，会在测评开头明确标注。价格与营业时间以测评当时的记录为准，
                实际可能变化，出发前请再确认。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}